import { render, staticRenderFns } from "./PathBox.vue?vue&type=template&id=1984e641&scoped=true&"
import script from "./PathBox.vue?vue&type=script&lang=ts&"
export * from "./PathBox.vue?vue&type=script&lang=ts&"
import style0 from "./PathBox.vue?vue&type=style&index=0&id=1984e641&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1984e641",
  null
  
)

export default component.exports